import { createContext as e } from "react";
const t = e(), r = t.Provider;
export {
  t as SelectContext,
  r as SelectProvider
};
